<template>
  <div class="content-area__heading">
    <h2 class="mb-6 flex mx-auto font-bold">
      <slot>{{ title }}</slot>
    </h2>
  </div>
</template>
<script>
export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      required: false,
      default: () => null
    }
  }
}
</script>
